import { CONFIG_URL } from './constants';

export type AdminConfig = {
  apiKey?: string;
  authDomain?: string;
  useEmulators?: boolean;
  authEmulatorHost?: string;
};

let cachedConfig: AdminConfig | null = null;

export const getConfig = async (): Promise<AdminConfig> => {
  if (cachedConfig) return cachedConfig;

  const res = await fetch(CONFIG_URL);
  if (!res.ok) {
    throw new Error('Admin auth configuration is missing on the server.');
  }

  const config = (await res.json()) as AdminConfig;
  cachedConfig = config;
  return config;
};
